import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Footer } from './Footer';
import { Header } from '../components/Header';
import type { Rule } from 'antd/lib/form';
import type { FormData } from '@/context/CalculatorReturnOfInvestment/types';
import * as S from '../../styles';

export function Personal() {
	const fieldName: keyof FormData = 'personal';

	const emailValidation: Rule[] = [
		{ required: true, message: I18n.get('Please enter your email.') },
		{ type: 'email', message: I18n.get('Invalid email address.') }
	];

	const phoneValidation: Rule[] = [
		{ required: true, message: I18n.get('Please enter your phone number.') },
		{ pattern: /^\d+$/, message: I18n.get('Must be only numbers') },
		{ max: 15, message: I18n.get('Phone must be less than 15 characters.') }
	];

	return (
		<Row gutter={[0, 35]}>
			<Col span={24}>
				<Header title="Personal information" />
			</Col>
			<Col span={24}>
				<Row gutter={[20, 20]}>
					<Col xs={24} md={12}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							label={I18n.get('Full name')}
							name={[fieldName, 'full_name']}
							rules={[{ required: true, message: I18n.get('Please enter your full name.') }]}
						>
							<S.CustomInput placeholder={I18n.get('Enter your full name')} />
						</S.RequiredFormItem>
					</Col>
					<Col xs={24} md={12}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							rules={emailValidation}
							label={I18n.get('Email')}
							name={[fieldName, 'email']}
						>
							<S.CustomInput placeholder={I18n.get('Enter your email')} />
						</S.RequiredFormItem>
					</Col>
					<Col xs={24} md={12}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							rules={phoneValidation}
							label={I18n.get('Phone')}
							name={[fieldName, 'phone']}
						>
							<S.CustomInput placeholder={I18n.get('Enter your phone number')} />
						</S.RequiredFormItem>
					</Col>
					<Col xs={24} md={12}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							label={I18n.get('Position')}
							name={[fieldName, 'position']}
							rules={[{ required: true, message: I18n.get('Please enter your position.') }]}
						>
							<S.CustomInput placeholder={I18n.get('Enter your position')} />
						</S.RequiredFormItem>
					</Col>
					<Col span={24}>
						<S.RequiredFormItem
							labelCol={{ span: 24 }}
							label={I18n.get('Company')}
							name={[fieldName, 'company_name']}
							rules={[{ required: true, message: I18n.get('Please enter your company name.') }]}
						>
							<S.CustomInput placeholder={I18n.get('Enter your company name')} />
						</S.RequiredFormItem>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Footer />
			</Col>
		</Row>
	);
}
